import AlarmLightIcon from './AlarmLightIcon';
export default AlarmLightIcon;
